import React from 'react';
import { Button, Form, Input, InputNumber, Select, Typography } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { TCalendar } from '../../models/wpbotModel';
import { calendarSelectOptions, newServiceId } from '../../utils/calendars';

/**
 * Campos de calendario + servicios (eventos personalizados).
 * Van dentro de un Form de antd (el del alta o el de Aplicaciones).
 */
const BotCalendarFields: React.FC<{
  calendars: TCalendar[];
  loading?: boolean;
  calendarId?: string;
  required?: boolean;
  onCalendarChange?: (value: string | undefined) => void;
}> = ({ calendars, loading, calendarId, required, onCalendarChange }) => {
  return (
    <>
      <Form.Item
        label="Calendario"
        name="calendar_id"
        rules={required ? [{ required: true, message: 'Selecciona un calendario' }] : undefined}
      >
        <Select
          showSearch
          allowClear
          optionFilterProp="label"
          loading={loading}
          placeholder="Selecciona un calendario"
          options={calendarSelectOptions(calendars)}
          notFoundContent={loading ? "Cargando..." : "No hay calendarios disponibles"}
          onChange={onCalendarChange}
        />
      </Form.Item>

      {calendarId && (
        <>
          <Typography.Text strong>Servicios / tipos de cita</Typography.Text>
          <Typography.Paragraph type="secondary" style={{ marginTop: 4 }}>
            Crea lo que ofrezca el negocio. El bot se los lee al cliente para que elija.
          </Typography.Paragraph>
          <Form.List name="customEvents">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div key={key} style={{ display: 'flex', marginBottom: 8, gap: 8, alignItems: 'baseline' }}>
                    <Form.Item {...restField} name={[name, 'id']} hidden>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'name']}
                      rules={[{ required: true, message: 'Falta el nombre' }]}
                      style={{ flex: 1, marginBottom: 0 }}
                    >
                      <Input placeholder="Ej. Corte de cabello, Barba, Corte + Barba" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'duration']}
                      rules={[{ required: true, message: 'Falta la duración' }]}
                      style={{ width: 140, marginBottom: 0 }}
                    >
                      <InputNumber placeholder="Duración" suffix="min" min={1} style={{ width: '100%' }} />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </div>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add({ id: newServiceId(), duration: 30 })} block icon={<PlusOutlined />}>
                    Añadir servicio
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </>
      )}
    </>
  );
};

export default BotCalendarFields;
